/**
 * POD API base URL (axios).
 *
 * - Empty / same-origin: requests use `/api/...` on the current host (nginx proxies to backend).
 * - Absolute URL: for local Vite dev hitting backend directly (e.g. http://localhost:9600).
 *
 * Vite inlines `import.meta.env.VITE_API_URL` at build time — set it in `.env` (dev) or Docker build-args (deploy).
 */
export function getPodApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_URL
  if (raw == null || raw === '') return ''

  const trimmed = String(raw).trim()
  if (trimmed === '/' || trimmed.toLowerCase() === 'same-origin') return ''

  return trimmed.replace(/\/+$/, '')
}
